import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import {Col} from "reactstrap";
import ObjectSelect from "../components/ObjectSelect";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro úpravu fakturační položky na objednávce.
 */
class ObjednavkaEditPolozkaForm extends Component<WithTranslation> {

    static formName = 'ObjednavkaEditPolozkaForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.polozka) {
            errors.polozka = t('validation.item_required');
        }
        if (!values.mnozstvi) {
            errors.mnozstvi = t('validation.amount_required');
        }
        return errors;
    };

    componentDidMount() {
        const {cena, sleva, specCena} = this.props.initialValues;
        this.setState({
            puvodniCena: cena,
            puvodniSleva: sleva,
            puvodniSpecCena: specCena,
        })
    }

    handleCenaChange = (_, novaCena) => {
        const {puvodniCena, puvodniSpecCena} = this.state;
        if (novaCena && puvodniCena !== Number(novaCena)) {
            this.props.change('specCena', true);
        } else {
            this.props.change('specCena', puvodniSpecCena);
        }
    };

    handleSlevaChange = (_, novaSleva) => {
        const {puvodniSleva, puvodniSpecCena} = this.state;
        if (novaSleva && puvodniSleva !== Number(novaSleva)) {
            this.props.change('specCena', true);
        } else {
            this.props.change('specCena', puvodniSpecCena);
        }
    };

    render() {
        const {onClose, submitting, handleSubmit, initialValues, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ObjectSelect
                    label={t('order.item')}
                    name="polozka"
                    items={[initialValues.polozka]}
                    itemValueAttrName="popisPolozka"
                    disabled={true}
                />
                <ff.Number int label={t('amount')} name="mnozstvi" disabled={submitting} addonsAfter={<Col xs={0} sm={9}/>}/>
                <ff.Number
                    double
                    name="cena"
                    label={t('price_per_mj')}
                    addonsAfter={<Col xs={0} sm={9}/>}
                    onChange={this.handleCenaChange}
                />
                <ff.Number
                    double
                    name="sleva"
                    label={t('discount')}
                    addonsAfter={<Col xs={0} sm={9}/>}
                    onChange={this.handleSlevaChange}
                />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(reduxForm({
    form: ObjednavkaEditPolozkaForm.formName,
    validate: ObjednavkaEditPolozkaForm.validate,
})(ObjednavkaEditPolozkaForm));
